<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >
    <!-- general tab -->
    <b-tab active>
      <!-- title -->
      <template #title>
        <feather-icon icon="UserIcon" size="18" class="mr-50" />
        <span class="font-weight-bold">Layanan</span>
      </template>

      <template>
        <b-card>
          <!-- form -->
          <b-form class="mt-2">
            <b-row>
              <b-col sm="12">
                <b-form-group label="Nama Lengkap">
                  <b-form-input
                    v-model="localData.name"
                    placeholder="Nama Lengkap"
                    name="namalengkap"
                    readonly
                  />
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <b-form-group label="Klien">
                  <b-form-input
                    v-model="localData.klien"
                    placeholder="Klien"
                    name="klien"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <b-form-group label="Layanan Yang Dilaksanakan:">
                  <b-form-input
                    v-model="localData.deskripsi"
                    placeholder="Ketik Di Sini"
                    name="layanan"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <b-form-group label="Jumlah Waktu">
                  <b-form-input
                    v-model="localData.jumlah_waktu"
                    name="waktu"
                    placeholder="Waktu Dalam Jam"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <b-form-group label="Lampiran:">
                  <b-row v-for="(x, y) in lampiran" :key="y" class="pb-2">
                    <b-col sm="11">
                      <b-form-file
                        v-model="x.lampiran"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                        v-if="x.value == ''"
                      />
                      <div v-else>
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="success"
                          class="mr-1"
                          @click="download(x.nama_file)"
                        >
                          <b-spinner
                            v-show="btnSimpanSpinnerShow"
                            small
                            type="grow"
                          />
                          {{ x.nama_file }}
                        </b-button>
                        <b-button
                          variant="danger"
                          @click="hapusLampiranDokumen(x.id)"
                          >X</b-button
                        >
                      </div>
                    </b-col>
                    <b-col sm="1" v-if="x.value == ''">
                      <b-button variant="danger" @click="hapusLampiran(y)"
                        >X</b-button
                      >
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      <b-button variant="warning" @click="tambahLampiran"
                        >Tambah Lampiran</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mt-2 mr-1"
                  @click="simpan"
                >
                  <b-spinner v-show="btnSimpanSpinnerShow" small type="grow" />
                  Simpan
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </template>
    </b-tab>
    <!--/ general tab -->
  </b-tabs>
</template>

<script>
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BSpinner,
  BTabs,
  BTab,
  BFormFile,
} from 'bootstrap-vue'
import { api, upload, download } from '@/hap-sia/setup'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BSpinner,
    BTabs,
    BTab,
    BFormFile,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      localData: {
        biodata_id: null,
        name: null,
        probono_laporan_id: null,
        deskripsi: null,
        jumlah_waktu: null,
        lampiran_list: {},
      },
      laporan_id: null,
      layanan_id: null,
      lampiran: [{ value: '' }],
      isEdit: false,
      btnSimpanSpinnerShow: false,
      masterUser: null,
      isPilihDPC: false,
      masterStrukturOrganisasi: null,
    }
  },
  computed: {},
  async mounted() {
    const tmpLaporanId = this.$route.params.id
    this.localData.biodata_id = this.$route.params.biodata_id

    // const userBiodata = await api().get(`probono/biodatabyuser/${tmpLaporanId}`)
    const tmpAksi = this.$route.params.aksi
    this.laporan_id = tmpLaporanId
    this.layanan_id = tmpLaporanId

    let temp

    if (tmpAksi === 'tambah') {
      temp = await api().get(`probono/laporan/${tmpLaporanId}`)
    } else {
      this.laporan_id = tmpLaporanId
      this.isEdit = true
      temp = await api().get(`probono/layanan/${tmpLaporanId}`)
      this.localData.klien = temp.data.klien
      this.localData.deskripsi = temp.data.deskripsi
      this.localData.jumlah_waktu = temp.data.jumlah_waktu
      this.laporan_id = temp.data.probono_laporan_id
      this.lampiran = temp.data.probono_lampiran
    }

    // this.localData.user_id = temp.data.users[0].id
    // this.localData.biodata_id = userBiodata.data.biodata[0].id
    this.localData.name = temp.data.biodata[0].nama_lengkap
    this.localData.probono_laporan_id = tmpLaporanId
  },
  methods: {
    async download(filename) {
      try {
        this.btnDownloadDisabled = true
        const result = await download().get(
          `probono/download/${this.laporan_id}/${filename}`,
        )
        const url = window.URL.createObjectURL(new Blob([result.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename) // or any other extension
        document.body.appendChild(link)
        link.click()
      } catch (error) {
        alert(error)
      }
    },
    hapusLampiran(index) {
      this.lampiran.splice(index, 1)
    },
    hapusLampiranDokumen(id) {
      this.$bvModal
        .msgBoxConfirm('Apakah anda yakin?', {
          cancelVariant: 'outline-secondary',
          okTitle: 'Delete',
          okVariant: 'danger',
        })
        .then(async value => {
          if (value) {
            await api().delete(`probono/lampiran/${id}`)
            this.makeToast('success', 'Sukses', 'Lampiran berhasil dihapus')
            this.$router.go()
          }
        })
    },
    tambahLampiran() {
      this.lampiran.push({
        value: '',
      })
    },
    async simpan() {
      if (
        !this.localData.klien ||
        !this.localData.deskripsi ||
        !this.localData.jumlah_waktu
      ) {
        this.makeToast('danger', 'Error', 'Semua Kolom Wajib Diisi', true)
        return
      }

      delete this.localData.name

      this.btnSimpanSpinnerShow = true
      try {
        const tempFiles = []
        if (this.lampiran) {
          this.lampiran.forEach(element => {
            const formData = new FormData()
            if (element.lampiran) {
              formData.append('file', element.lampiran)
              tempFiles.push(
                upload().post(`probono/${this.laporan_id}/upload`, formData),
              )
            }
          })
        }
        if (tempFiles) {
          let promises
          try {
            promises = await Promise.all(tempFiles)
          } catch (error) {
            this.makeToast('danger', 'Error', error, true)
          }
          const tempArray = []
          promises.forEach(element => {
            tempArray.push(element.data.filename)
          })
          this.localData.lampiran_list = tempArray
        }

        let result
        delete this.localData.name
        if (this.isEdit) {
          delete this.localData.biodata_id
          delete this.localData.probono_laporan_id
          this.localData.id = this.layanan_id
          result = await api().patch('probono/layanan', this.localData)
        } else {
          result = await api().post('probono/layanan', this.localData)
        }
        if (result) {
          this.$router.push(
            `/probono/layanan/${this.laporan_id}/${this.$route.params.biodata_id}`,
          )
        }
      } catch (error) {
        this.makeToast('danger', 'Error', error.response, true)
        return
      }
      this.makeToast('success', 'Sukses', 'Data berhasil ditambahkan')
    },
    makeToast(variant = null, title, body, noAutoHide = false) {
      this.$bvToast.toast(body, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
        noAutoHide,
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
